<template>
  <div class="mt-4">
    <radio-button-group
      :modelValue="draftValue"
      class="mb-16"
      :name="radioGroupName"
      :options="options"
      @update:model-value="onRadioSelection"
    />
  </div>
</template>

<script lang="ts">
import RadioButtonGroup from './RadioButtonGroup.vue';

export default {
  name: 'RadioListFilterPanel',
  components: { RadioButtonGroup },
  props: {
    options: {
      type: Array as () => Array<{ value: string; label: string; helperText?: string }>,
      required: true,
    },
    selectedValue: {
      type: String,
      required: true,
    },
    radioGroupName: {
      type: String,
      required: true,
    },
    closeModal: {
      type: Function,
      required: true,
    },
  },
  data(): { draftValue: string } {
    return {
      draftValue: this.selectedValue,
    };
  },
  watch: {
    selectedValue(value: string) {
      this.draftValue = value;
    },
  },
  methods: {
    onRadioSelection(value: string): void {
      this.draftValue = value;
      this.submitForm();
    },
    submitForm(): void {
      if (this.draftValue === this.selectedValue) return;
      this.$emit('filterApplied', { value: this.draftValue });
      this.closeModal();
    },
  },
};
</script>
